import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Urbaniaonrentinkolhapur() {



    const cardData =
    {
        keyword: 'Urbania On Rent in Kolhapur',
        heading: 'Urbania on rent in pune: Urbania On Rent in Kolhapur',
        headingDescription: 'Urbania On Rent in Pune offers reliable and comfortable Urbania On Rent in Kolhapur for corporate groups, families, tourists, and event travelers planning trips to and from Kolhapur. Our well‑maintained Force Urbania fleet provides spacious seating, air‑conditioned comfort, and smooth performance, making it ideal for long-distance travel, weekend getaways, corporate outings, airport transfers, weddings, sightseeing, and outstation journeys from Pune to Kolhapur. With professional chauffeurs, flexible one-way and round-trip rental options, and convenient doorstep pickup from major areas including Hinjewadi, Baner, Wakad, Kharadi, Hadapsar, Kothrud, Pimpri Chinchwad, and Pune Airport, we ensure a safe and stress-free travel experience. Backed by 24/7 booking support, punctual service, and transparent pricing, Urbania On Rent in Pune stands out as the trusted choice for premium Urbania hire in Kolhapur.',

        top: 'Top Places to Visit in Kolhapur with Urbania on rent in pune',


"topPlaces": [
  {
    "title": "Laxmi Vilas Palace",
    "description": "Laxmi Vilas Palace in Kolhapur is a grand heritage monument built by the rulers of the Kolhapur princely state. With Indo-Saracenic architecture, ornate halls, and royal artifacts, the palace offers a glimpse into regal lifestyles. Visitors can explore the museum, durbar hall, and sprawling gardens. Renting Urbania cabs makes it easy to visit this majestic spot comfortably from any part of Kolhapur."
  },
  {
    "title": "Mahalaxmi Temple",
    "description": "Mahalaxmi Temple, also known as Ambabai Temple, is one of the most revered Shakti Peethas in India, attracting devotees year-round. The sacred idol of Goddess Mahalaxmi and intricate stone carvings create a spiritually uplifting ambiance. Urbania on rent provides convenient transport for pilgrims and tourists to reach this iconic temple without the hassle of navigation or parking."
  },
  {
    "title": "Rankala Lake",
    "description": "Rankala Lake is a scenic waterbody surrounded by gardens, walking paths, and local food stalls. It is perfect for leisurely strolls, boating, and sunset views. Urbania rental vehicles offer a stress-free journey to this peaceful spot, ideal for families, couples, and photographers exploring Kolhapur’s serene lakeside attraction."
  },
  {
    "title": "Panhala Fort",
    "description": "Panhala Fort is one of Maharashtra’s largest hill forts with a rich Maratha history and panoramic views of the surrounding countryside. Visitors can explore ancient bastions, watchtowers, and scenic spots during the trek. Booking an Urbania on rent from Kolhapur gives you flexible travel time to reach the fort early for the best views and trekking experience."
  },
  {
    "title": "Shalini Palace",
    "description": "Shalini Palace, overlooking Rankala Lake, is a beautiful heritage building known for its combination of Indian and European architectural styles. Surrounded by lush gardens, it once served as a royal residence and later a luxury hotel. Urbania on rent simplifies travel to this elegant site, letting visitors enjoy heritage sightseeing at their own pace."
  },
  {
    "title": "Jyotiba Temple",
    "description": "The hilltop Jyotiba Temple is a revered pilgrimage site located about 17 km from Kolhapur. Known for its vibrant fairs and scenic hill views, it draws devotees and culture enthusiasts alike. Renting an Urbania cab ensures a comfortable and convenient trip up the winding roads to this spiritually significant location."
  },
  {
    "title": "Bhavani Mandap",
    "description": "Bhavani Mandap is a historical landmark that served as the royal court and administrative center during the reign of Chhatrapati Shahu Maharaj. With carved pillars, ancient weapons, and cultural exhibits, it offers rich insights into Kolhapur’s heritage. Urbania on rent makes it easy to include this heritage stop in your Kolhapur itinerary."
  },
  {
    "title": "Dajipur Wildlife Sanctuary",
    "description": "Dajipur Wildlife Sanctuary, also known as the Bison Sanctuary, is home to gaur, deer, leopards, and diverse bird species. The jungle safari and trekking trails provide an immersive nature experience. Using Urbania on rent to travel from Kolhapur to Dajipur allows visitors to enjoy the scenic route and wildlife adventure without worrying about self‑drive logistics."
  },
  {
    "title": "Kolhapur Market & Local Shopping",
    "description": "Kolhapur’s vibrant markets are known for traditional items like Kolhapuri chappals, leather goods, and handcrafted souvenirs. Exploring these local streets is a delight, and Urbania on rent helps tourists travel comfortably between multiple shopping stops across the city without the hassle of parking or navigation."
  },
  {
    "title": "New Palace (Shahu Palace) Museum",
    "description": "New Palace, also known as Shahu Palace, houses a museum featuring royal artifacts, paintings, weaponry, and vintage collections. The palace complex combines architectural beauty with historical storytelling. Renting an Urbania cab lets visitors cover this museum and other heritage destinations in Kolhapur efficiently during a single day trip."
  }
],






"services": [
    {
      "name": "Urbania on Rent in Kolhapur",
      "description": "Urbania on Rent in Kolhapur offers reliable and well-maintained Urbania buses for local and outstation travel. Ideal for families, corporate groups, and tourists, these buses provide comfort, spacious seating, and professional chauffeur service for a hassle-free journey across Kolhapur."
    },
    {
      "name": "Kolhapur Urbania Bus Hire",
      "description": "Kolhapur Urbania Bus Hire provides convenient rental services with AC and non-AC buses for city travel, sightseeing, and group tours. Perfect for families, corporate trips, and friends, ensuring a comfortable and safe journey."
    },
    {
      "name": "Urbania Rental Service Kolhapur",
      "description": "Urbania Rental Service Kolhapur offers flexible rental options for Urbania buses with professional drivers, suitable for corporate events, family outings, weddings, and outstation trips."
    },
    {
      "name": "Urbania AC Bus on Rent Kolhapur",
      "description": "Urbania AC Bus on Rent Kolhapur provides fully air-conditioned Urbania buses for comfortable city travel, corporate trips, and long-distance journeys. Ensures a smooth ride with climate-controlled interiors and experienced chauffeurs."
    },
    {
      "name": "Corporate Urbania Hire Kolhapur",
      "description": "Corporate Urbania Hire Kolhapur delivers professional transport solutions for business travel, office events, and employee commute. Features include AC buses, punctual service, and trained drivers for a seamless corporate experience."
    },
    {
      "name": "Urbania for Outstation Kolhapur",
      "description": "Urbania for Outstation Kolhapur offers AC and non-AC buses for long-distance travel, including weekend getaways, sightseeing tours, and intercity trips. Provides luggage support, comfortable seating, and courteous drivers familiar with the routes."
    },
    {
      "name": "Urbania Airport Transfer Kolhapur",
      "description": "Urbania Airport Transfer Kolhapur provides timely pick-up and drop services to and from Kolhapur Airport. Ideal for corporate travelers, tourists, and families seeking stress-free, comfortable, and punctual airport transport."
    },
    {
      "name": "Luxury Urbania Kolhapur",
      "description": "Luxury Urbania Kolhapur offers high-end air-conditioned buses with plush seating, modern interiors, and professional drivers. Perfect for VIP travel, weddings, corporate outings, and luxury family tours."
    },
    {
      "name": "Affordable Urbania Hire Kolhapur",
      "description": "Affordable Urbania Hire Kolhapur provides budget-friendly bus rental options for city travel, local sightseeing, and group outings without compromising on comfort, safety, or convenience."
    },
    {
      "name": "Chauffeur Driven Urbania Kolhapur",
      "description": "Chauffeur Driven Urbania Kolhapur ensures a stress-free travel experience with verified and experienced drivers. Ideal for families, corporate groups, and tourists who want a safe and comfortable ride across Kolhapur."
    },
    {
      "name": "Urbania for Wedding Events Kolhapur",
      "description": "Urbania for Wedding Events Kolhapur offers spacious and air-conditioned buses for wedding guests and party travel. Ensures punctual service, comfort, and elegance for special celebrations."
    },
    {
      "name": "Urbania for Corporate Travel Kolhapur",
      "description": "Urbania for Corporate Travel Kolhapur provides professional transport for business trips, client visits, and team outings. Features AC buses, trained chauffeurs, and reliable scheduling for stress-free corporate travel."
    },
    {
      "name": "Best Urbania Rental Kolhapur",
      "description": "Best Urbania Rental Kolhapur offers top-rated Urbania buses with excellent customer service, timely pickups, and comfortable travel for both local and outstation trips. Suitable for families, corporate groups, and tourists."
    },
    {
      "name": "Urbania Group Travel Kolhapur",
      "description": "Urbania Group Travel Kolhapur provides large-capacity buses for group outings, excursions, and tours. Ensures safe, comfortable, and convenient travel for friends, families, and corporate groups."
    },
    {
      "name": "Reliable Urbania Hire Kolhapur",
      "description": "Reliable Urbania Hire Kolhapur offers dependable and punctual Urbania bus services for city and outstation travel. Known for safety, comfort, and professional drivers, making group travel seamless and enjoyable."
    }
  ],
  "tableData": [
    ["Urbania on Rent in Kolhapur", "Kolhapur Urbania Bus Hire"],
    ["Urbania Rental Service Kolhapur", "Urbania AC Bus on Rent Kolhapur"],
    ["Corporate Urbania Hire Kolhapur", "Urbania for Outstation Kolhapur"],
    ["Urbania Airport Transfer Kolhapur", "Luxury Urbania Kolhapur"],
    ["Affordable Urbania Hire Kolhapur", "Chauffeur Driven Urbania Kolhapur"],
    ["Urbania for Wedding Events Kolhapur", "Urbania for Corporate Travel Kolhapur"],
    ["Best Urbania Rental Kolhapur", "Urbania Group Travel Kolhapur"],
    ["Reliable Urbania Hire Kolhapur", ""]
  ],


"whychoose": [
    {
        "WhyChooseheading": "Reliable Urbania On Rent in Kolhapur",
        "WhyChoosedescription": "Urbania On Rent in Kolhapur is perfect for group travel, family outings, corporate trips, weddings, and outstation journeys, providing comfort and spacious seating."
    },
    {
        "WhyChooseheading": "Spacious and Well-Equipped Force Urbania Vehicles",
        "WhyChoosedescription": "Urbania On Rent in Kolhapur offers modern Force Urbania vehicles with air-conditioning, ample legroom, and comfortable seating for long and short trips."
    },
    {
        "WhyChooseheading": "Professional and Experienced Drivers",
        "WhyChoosedescription": "Urbania On Rent in Kolhapur comes with skilled drivers familiar with Kolhapur, Pune, and nearby routes, ensuring safe, timely, and hassle-free travel."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Choose Urbania On Rent in Kolhapur for competitive rates with no hidden charges, making group and family travel budget-friendly."
    },
    {
        "WhyChooseheading": "24/7 Booking and Customer Support",
        "WhyChoosedescription": "Urbania On Rent in Kolhapur provides round-the-clock booking assistance and support for inquiries, reservations, and last-minute travel needs."
    },
    {
        "WhyChooseheading": "Flexible Rental Packages",
        "WhyChoosedescription": "Urbania On Rent in Kolhapur is available for hourly rentals, full-day bookings, multi-day trips, corporate travel, sightseeing tours, and customized packages."
    },
    {
        "WhyChooseheading": "Clean, Sanitized, and Well-Maintained Vehicles",
        "WhyChoosedescription": "All vehicles for Urbania On Rent in Kolhapur are regularly cleaned, sanitized, and maintained to ensure passenger safety and comfort."
    },
    {
        "WhyChooseheading": "Punctual and Reliable Service",
        "WhyChoosedescription": "Urbania On Rent in Kolhapur guarantees on-time pickups and dependable service, ensuring smooth and stress-free travel experiences."
    }
]
}

const faqData = [
    {
        question: 'Is Urbania On Rent in Kolhapur available for local and outstation travel?',
        answer: 'Yes, Urbania On Rent in Kolhapur can be booked for city travel, corporate trips, family outings, and long-distance journeys.',
    },
    {
        question: 'How can I book Urbania On Rent in Kolhapur?',
        answer: 'You can book Urbania On Rent in Kolhapur via phone, WhatsApp, or online for easy and quick reservations.',
    },
    {
        question: 'Why choose Urbania On Rent in Kolhapur?',
        answer: 'Urbania On Rent in Kolhapur offers spacious seating, professional drivers, clean vehicles, and transparent pricing for corporate, family, and group travel.',
    },
    {
        question: 'Are drivers experienced?',
        answer: 'Yes, all drivers for Urbania On Rent in Kolhapur are licensed, trained, and experienced in handling Force Urbania vehicles safely.',
    },
    {
        question: 'Can I customize pickup and drop-off locations?',
        answer: 'Absolutely. Urbania On Rent in Kolhapur allows flexible pickup and drop locations across Kolhapur and nearby areas.',
    },
    {
        question: 'Is Urbania On Rent in Kolhapur available 24x7?',
        answer: 'Yes, Urbania On Rent in Kolhapur operates 24x7 to meet your travel needs anytime.',
    },
    {
        question: 'Are hygiene and safety standards maintained?',
        answer: 'Yes, all vehicles are regularly sanitized, cleaned, and maintained to ensure passenger safety and comfort.',
    },
    {
        question: 'What payment options are available?',
        answer: 'Urbania On Rent in Kolhapur accepts UPI, digital wallets, credit/debit cards, bank transfers, and corporate billing options.',
    },
    {
        question: 'Is customer support available during trips?',
        answer: 'Yes, dedicated customer support is available throughout your journey for smooth and stress-free travel.',
    },
    {
        question: 'Can Urbania be used for corporate, family, and outstation trips?',
        answer: 'Yes, Urbania On Rent in Kolhapur is ideal for group trips, corporate travel, family outings, and long-distance journeys.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Ashok Patil',
        feedback: 'Urbania On Rent in Kolhapur provided a smooth and comfortable ride for our family trip. Spacious and reliable service.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Priyanka Deshmukh',
        feedback: 'We hired Urbania On Rent in Kolhapur for a corporate outing. Clean, punctual, and excellent service.',
        rating: 5,
    },
    {
        id: 3,
        name: 'Mr. Ramesh Kulkarni',
        feedback: 'Urbania On Rent in Kolhapur made our group travel hassle-free and enjoyable. Highly recommended.',
        rating: 5,
    },
];




























































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Urbania On Rent Pune", link: "urbania-on-rent-pune" },
        { place: "/images/keyword/2.jpg", text: "Urbania on Rent in Pimpri Chinchwad", link: "urbania-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/3.jpg", text: "Urbania Hire for Corporate Events in Pune", link: "urbania-hire-for-corporate-events-in-pune" },
        { place: "/images/keyword/4.jpg", text: "17 Seater Urbania on Rent in Pune", link: "17-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/5.jpg", text: "14 Seater Urbania on Rent in Pune", link: "14-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/6.jpg", text: "Urbania on Rent in Kharadi", link: "urbania-on-rent-in-kharadi" },
        { place: "/images/keyword/7.jpg", text: "Urbania on Rent in Hadapsar", link: "urbania-on-rent-in-hadapsar" },
        { place: "/images/keyword/8.jpg", text: "Urbania on Rent in Kothrud", link: "urbania-on-rent-in-kothrud" },
        { place: "/images/keyword/9.jpg", text: "Urbania On Rent in Bibwewadi", link: "urbania-on-rent-in-bibwewadi" },
        { place: "/images/keyword/10.jpg", text: "Urbania on Rent in Koregaon Park", link: "urbania-on-rent-in-koregaon-park" },
        { place: "/images/keyword/11.jpg", text: "Urbania On Rent in Kalyani Nagar", link: "urbania-on-rent-in-kalyani-nagar" },
        { place: "/images/keyword/12.jpg", text: "Urbania On Rent in Mundhwa Pune", link: "urbania-on-rent-in-mundhwa-pune" },
        { place: "/images/keyword/13.jpg", text: "Urbania Bus On Rent in Baner", link: "urbania-bus-on-rent-in-baner" },
        { place: "/images/keyword/14.jpg", text: "Urbania AC Bus On Rent in Aundh", link: "urbania-ac-bus-on-rent-in-aundh" },
        { place: "/images/keyword/15.jpg", text: "Urbania Bus On Rent in Hinjewadi", link: "urbania-bus-on-rent-in-hinjewadi" },
        { place: "/images/keyword/16.jpg", text: "Urbania on Rent in Bhosari", link: "urbania-on-rent-in-bhosari" },
        { place: "/images/keyword/17.jpg", text: "Urbania on Rent in Pune Station", link: "urbania-on-rent-in-pune-station" },
        { place: "/images/keyword/18.jpg", text: "Urbania On Rent in Chakan", link: "urbania-on-rent-in-chakan" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Moshi", link: "urbania-on-rent-in-moshi" },
        { place: "/images/keyword/20.jpg", text: "Urbania On Rent in Charholi Budruk", link: "urbania-on-rent-in-charholi-budruk" },
        { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Nigdi Pradhikaran", link: "urbania-on-rent-in-nigdi-pradhikaran" },
        { place: "/images/keyword/22.jpg", text: "Urbania On Rent in Lohegaon", link: "urbania-on-rent-in-lohegaon" },
        { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Wagholi", link: "urbania-on-rent-in-wagholi" },
        { place: "/images/keyword/24.jpg", text: "Urbania Rental Service in Pune", link: "urbania-rental-service-in-pune" },
        { place: "/images/keyword/25.jpg", text: "Best Urbania on Rent in Pune", link: "best-urbania-on-rent-in-pune" }
    ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Urbania On Rent in Kolhapur",
  "image": "https://urbaniaonrentpune.in/assets/images/urbania-kolhapur.jpg",
  "description": "Urbania On Rent in Kolhapur offers AC and non-AC Urbania buses for corporate trips, outstation travel, airport transfers, weddings, office trips, and group travel. Chauffeur-driven buses ensure safe, comfortable, and convenient transportation in Kolhapur and surrounding areas.",
  "brand": {
    "@type": "Brand",
    "name": "Urbania on Rent in Pune"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "950",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "4000",
    "availability": "https://schema.org/InStock",
    "url": "https://urbaniaonrentpune.in/urbania-on-rent-kolhapur"
  }
};







    return (
        <div>
<Helmet>
  <title>
    Call:+91 9209423113 | Urbania On Rent in Kolhapur | AC & Luxury Urbania Bus Hire 
  </title>

  <meta
    name="description"
    content="Book Urbania On Rent in Kolhapur for corporate trips, outstation travel, airport transfers, weddings, office trips, and group travel. AC and non-AC Urbania buses with chauffeur-driven service ensure safe, comfortable, and convenient transportation in Kolhapur."
  />

  <meta
    name="keywords"
    content="Urbania on Rent in Kolhapur, Kolhapur Urbania Bus Hire, Urbania Rental Service Kolhapur, Urbania AC Bus on Rent Kolhapur, Corporate Urbania Hire Kolhapur, Urbania for Outstation Kolhapur, Urbania Airport Transfer Kolhapur, Luxury Urbania Kolhapur, Affordable Urbania Hire Kolhapur, Chauffeur Driven Urbania Kolhapur, Urbania for Wedding Events Kolhapur, Urbania for Corporate Travel Kolhapur, Best Urbania Rental Kolhapur, Urbania Group Travel Kolhapur, Reliable Urbania Hire Kolhapur"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <div
                className="breadcumb-wrapper"
                
                data-overlay="black"
                data-opacity="3"
            >
                <div className="container">
                    <div className="breadcumb-content text-center">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/69.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>



                            <div className="shambhu-services">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="sh-service-card">

                                        <div className="sh-service-left">
                                            <div className="sh-service-icon">
                                                🚌
                                            </div>
                                        </div>

                                        <div className="sh-service-content">
                                            <h4 className="sh-service-title">{service.name}</h4>
                                            <p className="sh-service-desc">{service.description}</p>
                                        </div>

                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Urbania On rent in Pune </span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Urbania on rent in Pune </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919209423113" className="pc-call">+91 9209423113</a>
                                            <a href="tel:+917620411277 " className="pc-call">+91 7620411277 </a>
                                            <a href="tel:+919284718314" className="pc-call">+91 9284718314</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919209423113"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919209423113" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@urbaniaonrentpune.in" className="pc-email">
                                            booking@urbaniaonrentpune.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Urbania on rent in pune</strong><br />
                                            Saket Tata Power CHS, Swami Samarth Marg,
                                            Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                                            Maharashtra India - 400703
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Urbaniaonrentinkolhapur;